import { createPutApiCall } from '../../../../Helpers/api'

/**
 * From MetadataResource.java in wfo-server
 *
 * PUT handles all modifications to Metadata for the contact. It will update the
 * state of the whole set of metadata for a contact or an individual piece of
 * metadata can be specified.
 *
 * If a metadata key is provided (i.e. ~/api/rest/recording/contact/1/metadata/key) only
 * that key will be modified, leaving the rest of the metadata for that contact alone.
 *
 * If a metadata key is not provided, (i.e. ~/api/rest/recording/contact/1/metadata) the
 * whole set will be modified.
 *
 * In order to delete a piece of metadata, the the value for that key should be set to null.
 *
 *
 * @res.example Modify all metadata for a contact WARNING: THIS IS DOCUMENTED AS BEING IMPLEMENTED BUT ISNT ACTUALLY IMPLEMENTED
 * 	{@res.example.request PUT ~/api/rest/recording/contact/1/metadata
 * 		{"ssn:{"value":"012-34-5678","key":"ssn"},"comment":{"value":"This comment","key":"comment"}}
 * 	}
 *
 * @res.example Modify one key of metadata for a contact
 * 	{@res.example.request PUT ~/api/rest/recording/contact/1/metadata/ssn
 * 		{"value" : "012-34-5678","key" : "ssn"}
 * 	}
 *
 * @res.example Delete metadata (and modify others)
 * 	{@res.example.request PUT ~/api/rest/recording/contact/1/metadata
 * 		{"ssn:{"value":"012-34-5678","key":"ssn"},"comment":{"value":null,"key":"comment"}}
 * 	}
 *
 */
export const saveMetadataRoute = (productName, contactId) => `/api/rest/${productName}/contact/${contactId}/metadata`

export const saveMetadatumRoute = (productName, contactId, metadataKey) =>
  `/api/rest/${productName}/contact/${contactId}/metadata/${encodeURIComponent(metadataKey)}`

export default {
  saveMetadatum: (productName, contactId, metadataKey, parameters) =>
    createPutApiCall(saveMetadatumRoute(productName, contactId, metadataKey))(parameters),
  saveMetadata: (productName, contactId, parameters) =>
    createPutApiCall(saveMetadataRoute(productName, contactId))(parameters),
}
